// polyfills
import "@babel/polyfill"; // babel
import "custom-event-polyfill"; // CustomEvent
import "whatwg-fetch"; // fetch
import "raf"; // requestAnimationFrame
import "performance-polyfill"; // performance

import Vue from "vue";
import VueRouter from "vue-router";

import App from "./App.vue";

var _hmt = _hmt || [];
(function () {
  const hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?1ac041d11cb5e71aa96f4b8de8d7fe2d";
  const s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(hm, s);
})();

Vue.config.productionTip = true;

Vue.use(VueRouter);
const router = new VueRouter({
  // routes will be dynamically inserted after App has mounted
  routes: [],
});

new Vue({
  render: h => h(App),
  router,
}).$mount("#app");
